import { BlurbLogoIcon } from '../icons/icon-def/BlurbLogoIcon';
import clsx from 'clsx';
import React from 'react';
import { Outlet } from 'react-router-dom';

export const AuthLayout: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full sm:pb-8">
      <div
        className={clsx(
          'flex-1 self-stretch flex justify-center',
          'px-6 py-2 border-b',
          'sm:p-4 sm:border-none',
        )}
      >
        <div className="sm:w-[53px] w-[40px] pt-5">
          <BlurbLogoIcon />
        </div>
      </div>
      <Outlet />
    </div>
  );
};
